// extracted by mini-css-extract-plugin
export default {"paymentInputContainer":"PaymentDetails_paymentInputContainer__iy+bv","selectDate":"PaymentDetails_selectDate__K0Db8","UtrAndAmountDiv":"PaymentDetails_UtrAndAmountDiv__-V2JX"};